import classNames from "classnames";
import React, { useState } from "react";
import { intl } from "@fidget/common/i18n/TypedIntl";
import { ITopic } from "../../../models/topics/topic";
import settingsStyles from "../../../styles/settings.css";
import { TopicPicker } from "../../forms/topicPicker/topicPicker";
import { TopicList } from "./topicsList/topicList";
import styles from "./topicsSummary.css";

interface Props {
  assignedTopics: ITopic[];
  assignableTopics: ITopic[];
  tagGroupId?: string;
  onChange(topics: ITopic[]): void;
}
export const TopicsSummary = ({ assignedTopics, assignableTopics, onChange }: Props) => {
  const [isPicking, setIsPicking] = useState(false);

  return (
    <div>
      {isPicking ? (
        <TopicPicker
          onOutsideClick={() => setIsPicking(false)}
          className={styles.picker}
          values={assignableTopics.filter((t) => !assignedTopics.includes(t))}
          initialIsOpen
          onChange={(t) => onChange([...assignedTopics, t])}
          onStateChange={(_, state) => (!state.isOpen ? setIsPicking(false) : undefined)}
        />
      ) : (
        <p
          className={classNames(styles.add, settingsStyles["text-clickable"])}
          onClick={() => setIsPicking(true)}
        >
          + {intl.formatMessage("topics.add")}
        </p>
      )}
      <TopicList
        topics={assignedTopics}
        onDelete={(t) => onChange(assignedTopics.filter((at) => at.id !== t.id))}
      />
    </div>
  );
};
